import axios from 'axios'
const seo_dictionary = require('../assets/json/seo_dictionary.json')

export default {
    getDictionaryDataByRouteName(name) {
        return seo_dictionary[name]
    }
}